module.exports = __webpack_public_path__ + "img/icon-cykel_off.b86698d9.png";